import { isMobile } from "react-device-detect"

//icons
import { FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router";
import { imagenesAll } from "../asset/bgImg";


export const Footer =()=>{
  return(
    <>
      {isMobile ? <IsMobileFooter/> : <IsPcFooter  />}
    </>
  )
}

const IsMobileFooter =()=>{
  const navigate = useNavigate();

  const copiarNumero = (numeroWpp) => {
    navigator.clipboard.writeText(numeroWpp).then(() => {
      alert("Número copiado al portapapeles");
    });
    
  };
  return(
    <footer className=" bg-dark m_font_text_primary d-flex flex-column justify-content-between text-white align-items-center m_text_secondary" style={{ height: "750px" }}>
  <div className="w-100 d-flex flex-column text-center mt-5 pt-5">
    <h5 className="fs-2">LINKS</h5>
    <div onClick={() => navigate('blog')} className="mt-2 ponteid">Blog</div>
    <div className="my-3 ponteid">Lectura</div>
    <div className="ponteid">Articulos</div>
  </div>

  <div className="w-100 d-flex flex-column align-items-center ">
    <h1 className="text-center"><img className="w-50" src={imagenesAll.h1Logo} alt="ASTROGIGIX" /></h1>
    <span className="text-grey">
      <span onClick={() => navigate("/login")}>© 2025.</span> Todos los derechos reservados
    </span>
  </div>

  <div className="w-100 d-flex flex-column text-center mb-5 pb-5">
    <h5 className="fs-2">SEGUINOS!</h5>
    <a className="mt-2 text-white" target="_blank" href="https://www.instagram.com/astrogigix/">astrogigix <FaInstagram size={30} color='white' /></a>
    <a className="my-3 text-white" target="_blank" href="https://www.youtube.com/@AstroGigix">astrogigix <FaYoutube size={30} color='white' /></a>
    <a className="text-white" onClick={()=>copiarNumero('5493512437113')}>+54 9 351 243-7113 <FaWhatsapp size={30} color='white' /></a>
  </div>
</footer>

  )
}
const IsPcFooter =()=>{
  const copiarNumero = (numeroWpp) => {
  navigator.clipboard.writeText(numeroWpp).then(() => {
    alert("Número copiado al portapapeles");
  });
};
  const navigate = useNavigate();
  return(
    <footer className="bg-dark d-flex justify-content-between align-items-center mt-5 py-5 text-white m_font_text_primary m_text_secondary">
      <div className="d-flex flex-column justify-content-center align-items-start ms-5 ">
        <h5 className="fs-2">LINKS</h5>
        <div onClick={()=> navigate('blog')} className="mt-2 ponteid">Blog</div>
        <div className="my-3 ponteid" onClick={()=> navigate('/membresia')} >Membresia</div>
        <div className=" ponteid"><a className="text-white" href="https://docs.google.com/forms/d/19xJdvKKxDQ5DrYFDw4_jCDG8F1cYilyF98mr2LQzzdo/viewform?edit_requested=true" target="_blank" >Articulos</a></div> 
      </div>
      <div className="d-flex flex-column align-items-center">
        <h1 className="text-center"><img className="w-50" src={imagenesAll.h1Logo} alt="ASTROGIGIX" /></h1>
        <span className="text-grey"><span onClick={()=>navigate("/login")}>© 2025.</span>Todos los derechos reservados</span>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-end me-5 m_text_secondary">
        <h5 className="fs-2">SEGUINOS!</h5>
        <a className="mt-2 text-white" target="_blank" href="https://www.instagram.com/astrogigix/"> astrogigix <FaInstagram size={30}color='white'/></a>
        <a className="my-3 text-white" target="_blank" href="https://www.youtube.com/@AstroGigix"> astrogigix <FaYoutube size={30}color='white'/></a>
        <a className="text-white m_pointer" onClick={()=>copiarNumero('5493512437113')} >+54 9 351 243-7113 <FaWhatsapp size={30}color='white'/> </a> 
      </div>
    </footer>
  )
}